import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { useLoad } from "@redotech/react-util/load";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import { templateTypeLabel } from "@redotech/redo-model/email-builder";
import { SendEmailState } from "@redotech/redo-return-ui/flows/return-flow/send-email";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { Flex } from "@redotech/redo-web/flex";
import { Link } from "@redotech/redo-web/link";
import { SelectDropdown } from "@redotech/redo-web/select-dropdown";
import { Spinner, SpinnerStyle } from "@redotech/redo-web/spinner";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as selectCss from "./select.module.css";

export const SendEmailDetails = memo(function SendEmailDetails({
  state,
  stepSelect,
  setState,
}: StepTypeDetailsProps<SendEmailState>) {
  const marketingRpcClient = useRequiredContext(RedoMarketingRpcClientContext);
  const templatesLoad = useLoad(
    async (signal) => {
      const templates = await marketingRpcClient.getEmailTemplates(
        {},
        { signal },
      );
      return templates;
    },
    [marketingRpcClient],
  );
  const nextStepChange = useHandler((next: StepId | undefined) => {
    setState((state) => ({ ...state, next }));
  });

  return (
    <>
      <Flex align="center" gap="xs">
        <Text fontSize="xs" textColor="secondary">
          Email template -
        </Text>
        <Link to="../../email-templates">Create new</Link>
      </Flex>
      {templatesLoad.value ? (
        <SelectDropdown
          disabled={!templatesLoad.value}
          options={
            templatesLoad.value?.filter(
              (t) => t.category === "Order tracking",
            ) || []
          }
          value={templatesLoad.value?.find(
            (template: any) => template._id === state.emailId,
          )}
          valueChange={(e: any) =>
            setState((state) => ({
              ...state,
              emailId: e._id,
              emailName: e.name,
              emailType: e.templateType,
            }))
          }
        >
          {(type) => (
            <div className={selectCss.value}>
              <div className={selectCss.title}>{`${type.name}${
                type.templateType
                  ? ` - ${templateTypeLabel(type.templateType)}`
                  : ""
              }`}</div>
            </div>
          )}
        </SelectDropdown>
      ) : (
        <div style={{ width: "21px", marginLeft: "auto", marginRight: "auto" }}>
          <Spinner style={SpinnerStyle.AUTO} />
        </div>
      )}
      <Text fontSize="xs" textColor="secondary">
        Next step
      </Text>
      {stepSelect({ value: state.next, valueChange: nextStepChange })}
    </>
  );
});
